import Vue from "vue";
import Vuex from "vuex";
import user from "./modules/user";
import group from "./modules/group";
import permission from "./modules/permission";
import dept from "./modules/dept";
import sca from "./modules/sca";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    group,
    permission,
    dept,
    sca
  }
});
